import { Pipe, PipeTransform } from '@angular/core';
import { Translator } from './services/translator/translator.service';

@Pipe({
  name: 'translate',
  pure: false
})
export class TranslatePipe implements PipeTransform {

  data: any = {};

  constructor(private translate: Translator) {
    this.loadJson();
  }

  async loadJson() {
    let data = this.translate.GetTranslations();
    this.data = data;
  }

  transform(key: any): any {
    let data_ = this.data;
    if (!key) return key;
    
    // Si la clave contiene puntos, intentar acceso anidado
    if (typeof key === 'string' && key.includes('.')) {
      const keys = key.split('.');
      let value = data_;
      for (const k of keys) {
        if (value && typeof value === 'object' && k in value) {
          value = value[k];
        } else {
          return key; // Si no encuentra, devolver la clave original
        }
      }
      return value || key;
    }
    
    // Acceso directo
    return data_[key] || key;
  }

}
